import { useState, useEffect, useCallback } from "react";
import { Search, ChevronLeft, ChevronRight, Plus } from "lucide-react";
import api from "../../services/api";
import DoletasTxTable from "./DoletasTxTable";
import DoletasManualForm from "./DoletasManualForm";

export default function DoletasTransactions() {
  var _tx = useState([]);
  var transactions = _tx[0];
  var setTransactions = _tx[1];
  var _total = useState(0);
  var total = _total[0];
  var setTotal = _total[1];
  var _page = useState(1);
  var page = _page[0];
  var setPage = _page[1];
  var _loading = useState(true);
  var loading = _loading[0];
  var setLoading = _loading[1];
  var _status = useState("");
  var statusF = _status[0];
  var setStatusF = _status[1];
  var _role = useState("");
  var roleF = _role[0];
  var setRoleF = _role[1];
  var _search = useState("");
  var searchV = _search[0];
  var setSearchV = _search[1];
  var _showManual = useState(false);
  var showManual = _showManual[0];
  var setShowManual = _showManual[1];

  var fetchTx = useCallback(async function () {
    setLoading(true);
    try {
      var params = new URLSearchParams();
      params.append("page", page);
      params.append("limit", "30");
      if (statusF) params.append("status", statusF);
      if (roleF) params.append("user_role", roleF);
      if (searchV) params.append("search", searchV);
      var res = await api.get("/doletas/transactions?" + params.toString());
      setTransactions(res.data.transactions || []);
      setTotal(res.data.total || 0);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [page, statusF, roleF, searchV]);

  useEffect(function () { fetchTx(); }, [fetchTx]);

  var totalPages = Math.ceil(total / 30);

  return (
    <div className="space-y-4" data-testid="doletas-transactions-panel">
      <div className="bg-white rounded-xl border border-gray-200 p-4">
        <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
          <button onClick={function () { setShowManual(!showManual); }}
            className="flex items-center gap-2 px-4 py-2 bg-[#F26A4B] text-white rounded-lg text-sm font-medium hover:bg-[#E05A3B] transition-colors"
            data-testid="btn-manual-tx">
            <Plus className="w-4 h-4" />Transacao Manual
          </button>
          <div className="flex flex-wrap gap-2 w-full sm:w-auto">
            <div className="relative flex-1 sm:flex-none">
              <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input type="text" placeholder="Buscar..." value={searchV}
                onChange={function (e) { setSearchV(e.target.value); setPage(1); }}
                className="pl-9 pr-3 py-2 border border-gray-200 rounded-lg text-sm w-full sm:w-44"
                data-testid="search-tx" />
            </div>
            <select value={statusF} onChange={function (e) { setStatusF(e.target.value); setPage(1); }}
              className="px-3 py-2 border border-gray-200 rounded-lg text-sm" data-testid="filter-status-tx">
              <option value="">Todos Status</option>
              <option value="pending_approval">Pendente</option>
              <option value="approved">Aprovada</option>
              <option value="rejected">Rejeitada</option>
            </select>
            <select value={roleF} onChange={function (e) { setRoleF(e.target.value); setPage(1); }}
              className="px-3 py-2 border border-gray-200 rounded-lg text-sm">
              <option value="">Todos</option>
              <option value="client">Clientes</option>
              <option value="broker">Vendedores</option>
            </select>
          </div>
        </div>
        {showManual && <DoletasManualForm onCreated={fetchTx} onClose={function () { setShowManual(false); }} />}
      </div>
      <DoletasTxTable transactions={transactions} total={total} loading={loading} />
      {totalPages > 1 && (
        <div className="bg-white rounded-xl border border-gray-200 px-4 py-3 flex items-center justify-between">
          <span className="text-xs text-gray-500">Pagina {page} de {totalPages}</span>
          <div className="flex gap-1">
            <button disabled={page <= 1} onClick={function () { setPage(page - 1); }} className="p-1.5 rounded-lg hover:bg-gray-100 disabled:opacity-30"><ChevronLeft className="w-4 h-4" /></button>
            <button disabled={page >= totalPages} onClick={function () { setPage(page + 1); }} className="p-1.5 rounded-lg hover:bg-gray-100 disabled:opacity-30"><ChevronRight className="w-4 h-4" /></button>
          </div>
        </div>
      )}
    </div>
  );
}
